import React, { useState, useEffect } from "react";
import sobreNosImg from "../../img/sobreNos.jpg";
import Header from "../common/Header";
import Services from "../common/Services";
import BlogArticles from "../../../pages/institucional/blog/BlogArticles";
import MissaoVisaoValores from "./MissaoVisaoValores";
import ContactCTA from "../common/ContactCTA";
import MapAndCards from "../common/MapAndCards";
import { useTheme } from "../../contexts/ThemeContext";
import ContactDrawer from "../common/ContactDrawer";

const SLIDES = [
  {
    id: 1,
    title: "Quem é a Bianco Azure?",
    text: (
      <>
        <p className="text-gray-700 leading-relaxed mb-4 text-sm sm:text-base text-justify">
          Somos uma <b>empresa de soluções em saúde</b>, com uma <b>sólida reputação e experiência</b> no fornecimento de <b>produtos de qualidade</b> e <b>serviços inovadores</b>. Bem sucedida desde 2012, atuando em diversas localidades nos seguimentos: <b>Home Care, Equipamentos Respiratórios</b> e <b>Aparelhos Auditivos.</b>
        </p>
        <p className="text-gray-700 leading-relaxed mb-4 text-sm sm:text-base text-justify">
          Ao longo dos anos, temos nos comprometido a oferecer <b>soluções em saúde excepcionais,</b> com base em uma abordagem personalizada ao cliente.
        </p>
        <p className="text-gray-700 leading-relaxed text-sm sm:text-base text-justify">
          <b>Nossa equipe altamente qualificada e dedicada </b> é composta por <b> profissionais especialistas </b> em suas respectivas áreas, desde <b> médicos, enfermeiros, fisioterapeutas, fonoaudiólogas, terapeutas ocupacionais além de cuidadores e consultores. </b>
        </p>
      </>
    ),
    // Usamos a imagem de referência do projeto
    image: sobreNosImg,
    imageAlt: "Profissional de saúde segurando um globo",
  },
  {
    id: 2,
    title: "Nossa Abordagem e Valores",
    text: (
      <>
        <p className="text-gray-700 leading-relaxed mb-4 text-sm sm:text-base text-justify">
          Acreditamos firmemente na <b>importância da responsabilidade social,</b> respeitando a <b>privacidade e a dignidade</b> de cada cliente, e nos esforçamos para criar um <b>ambiente humanizado e seguro</b> em nossas instalações.
        </p>
      </>
    ),
    image: sobreNosImg,
    imageAlt: "Equipe médica reunida",
  },
  {
    id: 3,
    title: "Foco no Cliente e Inovação",
    text: (
      <>
        <p className="text-gray-700 leading-relaxed mb-4 text-sm sm:text-base text-justify">
          Nosso diferencial está na busca contínua por <b>inovação</b> e na <b>personalização do atendimento</b>, garantindo que cada cliente receba o suporte exato que necessita para o seu bem-estar.
        </p>
      </>
    ),
    image: sobreNosImg,
    imageAlt: "Cuidado humanizado",
  },
];
// ------------------------------

export default function Sobre() {
  const { theme } = useTheme();
  const [currentIndex, setCurrentIndex] = useState(0);
  const totalSlides = SLIDES.length;
  const currentSlide = SLIDES[currentIndex];

  // Lógica para rotação automática
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % totalSlides);
    }, 8000);
    return () => clearInterval(interval);
  }, [totalSlides]);

  const goToSlide = (index) => setCurrentIndex(index);

  // Largura da barra de progresso (em porcentagem)
  const progressBarWidth = (100 / totalSlides) * (currentIndex + 1);

  return (
    <div className="bg-slate-100 min-h-screen">
      <Header />

      {/* QUEM É A BIANCO AZURE (CARROSSEL FADE) */}
      <section className="max-w-7xl mx-auto pt-24 sm:pt-28 pb-16 px-6">
        <div className="bg-white p-6 sm:p-10 rounded-2xl shadow-lg">

          {/* Layout Principal: Texto (w-3/5) e Imagem (w-2/5) */}
          <div className="grid md:grid-cols-5 gap-8 sm:gap-12 items-center">

            {/* CONTAINER DO TEXTO (3/5) */}
            <div
              key={currentSlide.id}
              className="md:col-span-3 text-left transition-opacity duration-700 ease-in-out"
            >
              <p className="text-2xl sm:text-3xl font-bold text-sky-700 mb-6">
                {currentSlide.title}
              </p>
              <div className="text-gray-700">
                {currentSlide.text}
              </div>
            </div>

            {/* CONTAINER DA IMAGEM (2/5) */}
            <div className="md:col-span-2 flex justify-center mt-6 md:mt-0 relative h-full min-h-[400px]">
              <img
                src={currentSlide.image}
                alt={currentSlide.imageAlt}
                // Classes para a imagem: borda arredondada e sombra.
                className="rounded-2xl shadow-xl w-full max-w-sm object-cover"
              />
            </div>
          </div>

          {/* BARRA DE PROGRESSO E NAVEGAÇÃO (Rodapé Fixo) */}
          <div className="flex justify-between items-center mt-6 pt-4">

            {/* 1. BARRA DE PROGRESSO (Alinhada à Esquerda) */}
            <div className={`w-2/3 max-w-[670px] h-4 bg-[#e4e5e9] rounded overflow-hidden`}>
              {/* Cor azul do tema Bianco Azure */}
              <div
                className="h-full transition-all duration-700 ease-out rounded"
                style={{
                  width: `${progressBarWidth}%`,
                  backgroundColor: theme.progressBar || "#0284c7", // fallback azul padrão
                }}
              />
            </div>

            {/* 2. NAVEGAÇÃO (Bolinhas Alinhadas à Direita) */}
            <div className="flex justify-end space-x-3 md:pr-[200px]">
              {SLIDES.map((_, index) => (
                <div
                  key={index}
                  className="rounded-full flex border-[2px] border border-white"
                >
                  <button
                    onClick={() => goToSlide(index)}
                    className={`w-3 h-3 rounded-full transition-colors p-[6px] duration-300 border-[3px] ${index === currentIndex ? "bg-sky-700" : "bg-gray-300 hover:bg-gray-400"
                      }`}
                    aria-label={`Ir para o slide ${index + 1}`}
                  />
                </div>
              ))}
            </div>
          </div>

        </div>
      </section>

      {/* Componentes restantes */}
      <MissaoVisaoValores />
      <ContactCTA />
      <Services />
      <BlogArticles />
      <MapAndCards />
      <ContactDrawer
        message="Vim do site"
      />
    </div>
  );
}